import { format } from 'date-fns';
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const parseYearMonthDay = (value)=>{
    if (!DATE_PATTERN.test(value)) return null;
    const [year, month, day] = value.split('-').map(Number);
    return {
        year,
        month,
        day
    };
};
const toLocalDate = (param)=>{
    let { year, month, day } = param;
    return new Date(year, month - 1, day);
};
export const toDateOrNull = (value)=>{
    if (value == null) return null;
    const parsed = parseYearMonthDay(value);
    return parsed == null ? null : toLocalDate(parsed);
};
export const toIsoDate = (date)=>format(date, 'yyyy-MM-dd');
